import { Component } from '../flags.js'

export const Page = Component.pa100.div()
export const Title = Component.fs60.grey6.mono.div()
export const Button = Component.ba.ph25.pv20.c_pointer.uppercase.ls1.mono.b_sapphire2.sapphire5.bg_none.button()
export const Header = Component.flex.jc_between.ai_baseline.div()
export const Link = Component.text_dec_none.grey6.bb.b_grey2.a()
export const Text = Component.text_center.mt50.div()
export const Message = Component.ws_pre.text_center.mt40.div()